export default (graphComponentRef, renderingManager) => (documentObjectId) => {
    if (!graphComponentRef.current)
        return;
    const node = graphComponentRef.current.graph.nodes.find(n => n.tag && n.tag.Id === documentObjectId);
    if (node) {
        renderingManager.setWebGL2NodeStyle(node, false, false, false);
        graphComponentRef.current.graph.remove(node);
    }
};
